import type {FunctionComponent} from 'react';
import {useTranslation} from '@app/hooks/use-translation';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {Image} from '@app/components/Image';
import {useLocation} from '@app/hooks/use-location';
import type {LocalImageConfig} from '@app/hooks/use-local-image';
import {useLocalImage} from '@app/hooks/use-local-image';
import {useUser} from '@deezer/react-user';
import {LandingButtonLink} from '@app/components/landing-btn-link';
import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';
import {useAuthLink} from '@app/hooks/use-link';

const IMAGE_CONFIG: LocalImageConfig = {
	default: '3c556ce2cc06fce2ec342ab0e37e39be.png',
	fr: '84e6186ee7c341e8354ccdd9c0ceb20e.png',
};

export const LyricsHero: FunctionComponent = () => {
	const {t} = useTranslation();
	const {getDeezerUrl} = useLocation();
	const [user] = useUser();
	const src = useLocalImage(IMAGE_CONFIG);
	const {getRegistrationLink} = useAuthLink();
	return (
		<LandingIllustrationSection
			description={
				<>
					<LandingHeading as="h1">
						{t('featureslandingpage_title_singalongwithlyrics_standalone-web', {
							ns: 'features',
						})}
					</LandingHeading>
					<LandingParagraph>
						{t('lyricslandingpage_text_singalongwithlyrics_standalone-web', {
							ns: 'lyrics',
						})}
					</LandingParagraph>
					<LandingButtonLink
						tracking={{eventaction: 'signup'}}
						href={
							user?.isConnected()
								? getDeezerUrl('/open_app')
								: getRegistrationLink()
						}
						isMain
					>
						{t('generic_action_signuptotry_standalone-web', {ns: 'common'})}
					</LandingButtonLink>
				</>
			}
			image={
				<Image
					src={src}
					aspectRatio="2880/840"
					alt={t(
						'featureslandingpage_title_singalongwithlyrics_standalone-web',
						{ns: 'features'},
					)}
					priority
				/>
			}
		/>
	);
};
